import React, { useEffect, useState } from 'react';
import {HashRouter as Router} from 'react-router-dom';
import { ConfigProvider, Modal } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import Header from "./components/Header";
import ErrorBoundary from "./components/ErrorBoundary";
import AppRoutes from "./routes";
import Monitor from "./pages/Monitor";
import './i18n';
import { useTranslation } from './hooks/useTranslation';

function App() {
  const { currentLanguage, t } = useTranslation();
  const [locale, setLocale] = useState(currentLanguage === 'zh' ? zhCN : enUS);

  useEffect(() => {
    // 根据当前语言设置 Ant Design 的 locale
    setLocale(currentLanguage === 'zh' ? zhCN : enUS);
  }, [currentLanguage]);

  useEffect(() => {
    const isLocalhost = /^localhost$|^127\.0\.0\.1$/i.test(window.location.hostname);
    if (window.location.protocol !== 'https:' && !isLocalhost) {
      const httpsUrl = window.location.href.replace(/^http:/, 'https:');
      Modal.warning({
        title: t('httpsWarning.title'),
        content: (
          <>
            <p>{t('httpsWarning.description')}</p>
            <p>
              <a
                href={httpsUrl}
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = httpsUrl;
                }}
              >
                {httpsUrl}
              </a>
            </p>
          </>
        ),
        okText: t('httpsWarning.goToHttps'),
        onOk: () => {
          window.location.href = httpsUrl;
        },
      });
    }
  }, [t]);

  return (
    <ConfigProvider locale={locale}>
      <Router>
        <div className="App">
          <ErrorBoundary>
            <Header />
          </ErrorBoundary>
          
          <main style={{ minHeight: 'calc(100vh - 56px)' }}>
            <AppRoutes />
          </main>

          <ErrorBoundary>
            <Monitor/>
          </ErrorBoundary>
        </div>
      </Router>
    </ConfigProvider>
  );
}

export default App;
